/**
 * Order-related helpers for engraving: line items filtering and user upload images.
 */

export function productCategory(title) {
  const t = (title || '').toLowerCase()
  if (t.includes('finger')) return 'fingerprint'
  if (t.includes('nasen')) return 'pet_nose_print'
  if (t.includes('pfoten') || t.includes('paw')) return 'pet_paw_print'
  if (t.includes('handschrift') || t.includes('zeichnung')) return 'handwriting'
  if (t.includes('fuß')) return 'baby_feet'
  if (t.includes('hand')) return 'baby_hands'
  return 'other'
}

export function getEngravingLineItems(order, productCategoryFn = productCategory) {
  const items = order?.lineItems || []
  return items.filter((li) => productCategoryFn(li?.title || li?.name || '') !== 'other')
}

/** Re-export for backward compatibility; prefer importing from BacksideEngraving. */
export { getBacksideEngravingLineItems, getBacksideEngravingFromLineItem } from './BacksideEngraving'

export function getPropertyValue(lineItem, propertyNames) {
  for (let propertyName in propertyNames) {
    const foundValue =
      (lineItem.properties || []).find(({ name }) => name.includes(propertyName))?.value || ''
    if (foundValue) {
      return foundValue
    }
  }
  return ''
}

/** True if the value looks like a URL (http/https or data URI), not plain text. */
export function isLikelyUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return false
  const s = value.trim()
  return s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:')
}

/** Return all property values whose name matches any of the given substrings (e.g. ['File Upload', 'File ']). */
export function getPropertyValuesMatching(lineItem, nameSubstrings) {
  const props = lineItem?.properties || []
  return props
    .filter(({ name, value }) => {
      if (!value || typeof value !== 'string' || !String(value).trim()) return false
      return nameSubstrings.some((sub) => (name || '').includes(sub))
    })
    .map(({ value }) => String(value).trim())
}

// TODO: make it single source of truth (SSoT) e.g. use it in ManageMizodiaOrders ... make all the functions here SSoT
export function getUserUploadImages(order) {
  const images = [...(order?.metafieldImages || [])]
  const lineItems = order?.lineItems || []
  const fileUploadNames = ['File Upload', 'File ']
  lineItems.forEach((lineItem) => {
    const values = getPropertyValuesMatching(lineItem, fileUploadNames)
    values.forEach((url) => images.push(url))
  })
  return images.filter((url) => isLikelyUrl(url)).map((url) => ({ id: url, imageUrl: url }))
}
